module.exports = __webpack_public_path__ + "img/zaw.6d7b494e.png";